<template>
  <div
    v-memo="slices"
    class="content-types"
  >
    <component
      :is="getSliceComponent(slice)"
      v-for="(slice, index) in slices"
      :key="index"
      :slice="slice"
      :index="index"
      :slices="slices"
      class="content-type"
      :class="getSliceClass(slice)"
      :style="`--bg-color: ${slice?.Settings?.BackgroundColor || 'transparent'};`"
    />

    <!--  -->
  </div>
</template>

<script setup lang="ts">
import { hydrateOnVisible } from 'vue'

defineProps({
  slices: {
    type: Array,
    required: true,
  },
})

const getSliceClass = (slice: any) => {
  return [
    `content-type--${slice?.Settings?.SliceWidth?.toLowerCase()?.replace('_', '-') || 'layout-width'}`,
    {
      'content-type--has-background': slice?.Settings?.BackgroundColor,
    },
  ]
}

const getSliceComponent = (slice: any) => {
  switch (slice?.__typename?.replace('ComponentSlices', '')) {
    case 'BannerFeed':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/BannerFeed.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'BannerColumns':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/BannerColumns.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'BlogFeed':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/BlogFeed.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'Buttons':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/Buttons.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'Categories':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/Categories.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'Cookiebot':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/Cookiebot.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'CopyCollection':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/CopyCollection.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'FancyBanners':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/FancyBanners.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'Faq':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/Faq.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'Icons':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/Icons.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'Jotform':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/Jotform.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'LoyaltyProducts':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/LoyaltyProducts.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'MarqueItems':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/MarqueeItems.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'MediaFeed':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/MediaFeed.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'PageFeed':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/PageFeed.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'ProductsFeed':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/ProductsFeed.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'ProductsCollectionFeed':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/ProductsCollectionFeed.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'RichtextFeed':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/RichtextFeed.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'RichtextWithMedia':
    case 'RichtextWithImage':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/RichtextWithMedia.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'RichtextWithProduct':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/RichtextWithProduct.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'SaldoChecker':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/SaldoChecker.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'Spacer':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/Spacer.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'SpotlerProductSlider':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/SpotlerProductSlider.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'FeaturedProducts':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/FeaturedProducts.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'VideoEmbedFeed':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/VideoEmbedFeed.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'StoreOpenings':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/StoreOpenings.vue`),
        hydrate: hydrateOnVisible(),
      })
    case 'Usps':
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/Usps.vue`),
        hydrate: hydrateOnVisible(),
      })
    default:
      return defineAsyncComponent({
        loader: () => import(`~layers/app/components/Slices/Unknown.vue`),
        hydrate: hydrateOnVisible(),
      })
  }
}
</script>

<style>
@import url("~layers/app/components/Strapi/Slices.css");
</style>
